



















































































































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { BulkAction } from '@/enums/BulkAction';
import { Locale } from '@/enums/Locale';
import { default as VSelect } from 'vue-select';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormWysiwyg: () => import('@/components/forms/Wysiwyg.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    FormSearchProducts: () => import('@/components/forms/SearchProducts.vue'),
    FormBadgeSelect: () => import('@/components/forms/BadgeSelect.vue'),
    FormImageUpload: () => import('@/components/forms/ImageUpload.vue'),
    FormCheckbox: () => import('@/components/forms/Checkbox.vue'),
    LanguageSelector: () => import('@/components/parts/LanguageSelector.vue'),
  },
})
export default class PageCollectionsShow extends Vue {
  @Getter('collection/viewing') collection!: Collection;

  @Getter('workspace/selected') workspace!: Workspace;

  @Getter('collect/all') collects!: Collect[];

  @Action('collection/update') updateCollection!: (payload: { collection: Collection; workspaceId: number }) => Promise<Collection>;

  @Action('collection/create') createCollection!: (payload: { collection: Collection; workspaceId: number }) => Promise<Collection>;

  @Action('collection/delete') deleteCollection!: (payload: { id: number; workspaceId: number }) => Promise<Collection>;

  @Action('collect/bulk') bulkCollect!: (payload: { data: CollectBulkData; workspaceId: number }) => Promise<Collect>;

  @Action('collection-translation/index') indexCollectionTranslations!: (payload: {
    query?: IndexQuery<CollectionTranslation>;
    workspaceId: number;
  }) => Promise<{ data: CollectionTranslation[]; total: number }>;

  @Action('collection-translation/create') creatCollectionTranslation!: ({ data, workspaceId }: { data: CollectionTranslationData; workspaceId: number }) => Promise<CollectionTranslation>;

  @Action('collection-translation/update') updatCollectionTranslation!: ({
    id,
    data,
    workspaceId,
  }: {
    id: number;
    data: CollectionTranslationData;
    workspaceId: number;
  }) => Promise<CollectionTranslation>;

  i18n: string = 'views.collections.show';

  $refs!: Vue['$refs'] & {
    collectionForm: FormClass;
    deleteForm: FormClass;
  };

  formLoaded: boolean = false;

  popupDeleteCollection: boolean = false;

  payload: CollectionData = {
    name: '',
    is_top: false,
    description: '',
    ordinal: 0,
    sort_by: 'created_at_desc',
    status: 'draft',
    media: [],
  };

  translationPayload: CollectionTranslationData = {
    collection_id: 0,
    description: undefined,
    name: '',
    locale: Locale.NL_BE,
  };

  selectedProductIds: number[] = this.$store.getters['collect/all'].map((collect: Collect) => collect.product_id);

  collectsPayload: CollectBulkData = {
    collects: [],
  };

  selectedLanguage: Locale = process.env.VUE_APP_DEFAULT_LOCALE;

  collectionTranslationId?: number;

  productMediaUpdated(media: Array<{ default: number; highlight: number; name: string; path: string }>) {
    // @ts-ignore
    this.payload.media = media.map((file: { id?: number; default: number; highlight: number; name: string; path: string }, i: number) => {
      return {
        id: file.id,
        order: i + 1,
        path: file.path,
        name: file.name,
      };
    });
  }

  get productMedia() {
    return this.payload.media.map((media: ProductImage) => {
      return {
        id: media.id,
        path: media.path,
        name: media.name,
        default: media.order === 1 ? 1 : 0,
        highlight: media.order === 1 ? 1 : 0,
      };
    });
  }

  get inputName(): string {
    if (this.defaultLanguageSelected) {
      return this.payload.name;
    }
    return this.translationPayload.name;
  }

  set inputName(name: string) {
    if (this.defaultLanguageSelected) {
      this.payload.name = name;
    }
    this.translationPayload.name = name;
  }

  get inputDescription(): string | undefined {
    if (this.defaultLanguageSelected) {
      return this.payload.description;
    }
    return this.translationPayload.description;
  }

  set inputDescription(name: string | undefined) {
    if (this.defaultLanguageSelected) {
      this.payload.description = name!;
    }
    this.translationPayload.description = name;
  }

  get defaultLanguageSelected() {
    return process.env.VUE_APP_DEFAULT_LOCALE === this.selectedLanguage;
  }

  get localeDisabledClasses() {
    return { 'pointer-events-none opacity-50': !this.defaultLanguageSelected };
  }

  get submitFunction() {
    if (this.defaultLanguageSelected) {
      return this.handleSubmit;
    }
    return this.handleTranslationSubmit;
  }

  get sortByOptions() {
    return ['created_at_desc', 'created_at_asc', 'user_defined'];
  }

  async handleLanguageChange(language: Locale) {
    if (process.env.VUE_APP_DEFAULT_LOCALE === language) {
      this.selectedLanguage = language;
      return;
    }

    const translation = await this.indexCollectionTranslations({
      query: {
        q: {
          and: {
            collection_id: this.collection!.id,
            locale: language,
          },
        },
        per_page: 1,
      },
      workspaceId: this.workspace.id,
    });

    this.collectionTranslationId = translation?.data[0]?.id;
    this.translationPayload = {
      name: translation?.data[0]?.name ?? this.payload.name,
      description: translation?.data[0] !== undefined ? translation?.data[0].description : this.payload.description,
      locale: language,
      collection_id: this.collection!.id!,
    };
    this.selectedLanguage = language;
  }

  private handleDelete() {
    if (this.collection.id) {
      this.deleteCollection({ id: this.collection.id, workspaceId: this.workspace.id })
        .then(() => {
          this.$refs.deleteForm.handleSuccess();
          this.$router.push({ name: 'collections' });
          this.popupDeleteCollection = false;
        })
        .catch((e: ErrorResponse) => this.$refs.deleteForm.handleErrors(e));
    }
  }

  private handleSubmit() {
    let func: string = 'updateCollection';
    if (!this.collection?.id) {
      func = 'createCollection';
      this.payload.slug = this.slugify(this.payload.name);
    }

    // @ts-ignore
    this[func]({ id: this.collection?.id, data: this.payload, workspaceId: this.workspace.id })
      .then((collection: Collection) => {
        const collectCrudItems = this.buildCollectCrud(collection, this.selectedProductIds);
        if (collectCrudItems.length === 0) {
          this.handleSuccess(collection, func);
          return;
        }
        this.bulkCollect({ data: { collects: collectCrudItems }, workspaceId: this.workspace.id }).then(() => {
          this.handleSuccess(collection, func);
        });
      })
      .catch((e: ErrorResponse) => this.$refs.collectionForm.handleErrors(e));
  }

  private handleTranslationSubmit() {
    if (this.collectionTranslationId === undefined) {
      this.creatCollectionTranslation({ data: this.translationPayload, workspaceId: this.workspace.id })
        .then((collectionTranslation) => {
          this.collectionTranslationId = collectionTranslation.id;
          this.$refs.collectionForm.handleSuccess();
        })
        .catch((e: ErrorResponse) => this.$refs.collectionForm.handleErrors(e));
      return;
    }
    this.updatCollectionTranslation({ id: this.collectionTranslationId, data: this.translationPayload, workspaceId: this.workspace.id })
      .then(() => {
        this.$refs.collectionForm.handleSuccess();
      })
      .catch((e: ErrorResponse) => this.$refs.collectionForm.handleErrors(e));
  }

  private handleSuccess(collection: Collection, func: string) {
    this.$refs.collectionForm.handleSuccess();
    if (func === 'createCollection' && collection.id) {
      this.$router.push({ name: 'collections-detail', params: { id: `${collection.id}` } });
    }
  }

  private buildCollectCrud(collection: Collection, selectedIds: number[]): CollectBulkItem[] {
    const collectBulkItems: CollectBulkItem[] = [];
    selectedIds.forEach((selectedId, index) => {
      let comparisonCollect: Collect | null = this.collects[index] ?? null;
      if (comparisonCollect !== null && comparisonCollect.product_id === selectedId && comparisonCollect.ordinal === index) {
        return;
      }

      comparisonCollect = this.collects.find((collect) => collect.product_id === selectedId) ?? null;

      collectBulkItems.push({
        action: comparisonCollect === null ? BulkAction.CREATE : BulkAction.UPDATE,
        id: comparisonCollect?.id,
        collection_id: collection.id,
        product_id: selectedId,
        ordinal: index,
      });
    });

    this.collects.forEach((collect) => {
      const foundSelected = this.selectedProductIds.find((productId) => productId === collect.product_id);
      if (foundSelected !== undefined) {
        return;
      }
      collectBulkItems.push({
        action: BulkAction.DELETE,
        id: collect.id,
      });
    });

    return collectBulkItems;
  }

  private slugify(text: string) {
    return text
      ?.toLowerCase()
      ?.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      ?.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      ?.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      ?.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      ?.replace(/đ/gi, 'd')
      ?.replace(/\s*$/g, '')
      ?.replace(/\s+/g, '-');
  }

  @Watch('collection', { immediate: true, deep: true })
  private handleCollectionChanged(val: Collection) {
    if (!val) {
      return undefined;
    }

    this.payload = JSON.parse(JSON.stringify(val));
  }

  @Watch('workspace')
  private workspaceChanged(val: Workspace) {
    this.$router.push({ name: 'collections' });
  }
}
